import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const ModelWrapper = ({ isOpen, setIsOpen, children, Title, isLoading, setIsLoading }) => {

    return (
        <div>
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 z-[999] flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm"
                        onClick={() => setIsOpen((prev) => !prev)}
                    >
                        <motion.div
                            initial={{ scale: 0.9, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.9, opacity: 0 }}
                            className="relative max-h-[90vh] overflow-auto rounded-lg bg-white shadow-sm"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="px-8 py-4">
                                <h5 className="text-center text-xl mb-3 font-semibold tracking-wide text-black">
                                    {Title}
                                </h5>
                                {children}
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default ModelWrapper;